import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/iscrittiNewsletter';
import { selectors, DEFAULT_STATE } from '../reducers/iscrittiNewsletter';
import api from '../apis/iscrittiNewsletter';

const sagas = helper.createSagas(
    'iscrittiNewsletter',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE,
    {
        numberFilters: ['magnews_id_database']
    }
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
